import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
const getUserLogs = gql`
  query GetAllUserErrorLogs {
    getAllUserErrorLogs {
      id
      Route
      UserName
      PageName
      IP_Address
      Document_Ids
      Document_uniqueId
      createdAt
      updatedAt
    }
  }
`;
const ErrorLogs = () => {
  const [isLoading, setIsLoading] = useState(true);

  const {
    loading: queryLoading,
    data,
    refetch,
  } = useQuery(getUserLogs, {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  useEffect(() => {
    refetch()
      .then((res) => {})
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>
        <HeaderDiv title="Error Logs" TableKey={"Error_Logs"} />
        {isLoading ? (
          <Loading />
        ) : !data?.getAllUserErrorLogs?.length ? (
          <p className="DataNotAvailable">Data not Available</p>
        ) : (
          <>
            {queryLoading && <div className="loader-line-div" />}
            <LoadTable title="Error_Logs" data={data?.getAllUserErrorLogs} loading={isLoading} error={false} />
          </>
        )}
      </div>
    </>
  );
};

export default ErrorLogs;
